import {sumByProperty,sumFlyknitByProperty, percentOfTotal} from '../../helpers';

export const sumMaterialSection = (subSectionLineItems, Total ,cbdHeader) => {
  const totalAirbag = sumByProperty (
    subSectionLineItems.Airbag,
    'costsheetLandedCostUSD'
  );

  const totalUpper = sumByProperty (
    subSectionLineItems.Upper,
    'costsheetLandedCostUSD'
  );

  const flyKnitCost = (cbdHeader.costsheetUpperLandedCostFlyknit && cbdHeader.costsheetUpperLandedCostFlyknit !=="")?cbdHeader.costsheetUpperLandedCostFlyknit:
      sumFlyknitByProperty (
          subSectionLineItems.Upper,
          'costsheetLandedCostUSD',
          'costsheetMaterialProfitExclusionIndicator'
      );
  const nonFlyKnit = (cbdHeader.costsheetUpperLandedCostNonFlyknit && cbdHeader.costsheetUpperLandedCostNonFlyknit !== "")?cbdHeader.costsheetUpperLandedCostNonFlyknit:
      totalUpper - flyKnitCost;

  const totalPackaging = sumByProperty (
    subSectionLineItems.Packaging,
    'costsheetLandedCostUSD'
  );

  const totalMidsole = sumByProperty (
    subSectionLineItems.midsole,
    'costsheetLandedCostUSD'
  );

  const totalOutsole = sumByProperty (
    subSectionLineItems.Outsole,
    'costsheetLandedCostUSD'
  );

  const summedTotal =
    totalAirbag + totalUpper + totalPackaging + totalMidsole + totalOutsole;

  return [
    {
      detail: 'Upper',
      cost: totalUpper,
      percentOfTotal: percentOfTotal (Total, totalUpper),
    },
      {
          detail: 'Flyknit',
          cost: flyKnitCost,
          percentOfTotal: percentOfTotal (totalUpper, flyKnitCost),
      },
      {
          detail: 'NonFlyknit',
          cost:nonFlyKnit,
          percentOfTotal: percentOfTotal (totalUpper, nonFlyKnit),
      },
    {
      detail: 'Midsole',
      cost: totalMidsole,
      percentOfTotal: percentOfTotal (Total, totalMidsole),
    },
    {
      detail: 'Outsole',
      cost: totalOutsole,
      percentOfTotal: percentOfTotal (Total, totalOutsole),
    },
    {
      detail: 'Airbag',
      cost: totalAirbag,
      percentOfTotal: percentOfTotal (Total, totalAirbag),
    },
    {
      detail: 'Packaging',
      cost: totalPackaging,
      percentOfTotal: percentOfTotal (Total, totalPackaging),
    },
    {
      detail: 'Total',
      cost: summedTotal,
      percentOfTotal: percentOfTotal (Total, summedTotal),
    },
  ];
};



// WEBPACK FOOTER //
// ./src/dataMappingUIHelpers/subSectionMapping/materialSection.js